import { Box2, Vector2, Vector3 } from 'three';
const isBoxIntersectsBoundary = (boundary) => (box) => {
    const boundaryBox = new Box2(new Vector2(boundary.minX, boundary.minY), new Vector2(boundary.maxX, boundary.maxY));
    const screenBox = new Box2(new Vector2(box.x, box.y), new Vector2(box.x + box.width, box.y + box.height));
    return boundaryBox.intersectsBox(screenBox);
};
const emptyPadding = {
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
};
export class IntersectionService {
    constructor(screenSize, positionService, boundingService, settings = {}) {
        var _a, _b;
        this.screenSize = screenSize;
        this.positionService = positionService;
        this.boundingService = boundingService;
        const padding2D = Object.assign({}, emptyPadding, (_a = settings.padding2D) !== null && _a !== void 0 ? _a : {});
        const padding3D = Object.assign({}, emptyPadding, (_b = settings.padding3D) !== null && _b !== void 0 ? _b : {});
        this.settings = {
            padding3D,
            padding2D,
        };
    }
    init(screenBoxes, root) {
        this.screenBoxes = screenBoxes;
        this.root = root;
        this.bbox = this.getBoundingBox();
    }
    getBoundingBox() {
        const { top, left, right, bottom } = this.settings.padding3D;
        const bbox = this.boundingService.getBoundingBox(this.root).clone();
        bbox.max.add(new Vector3(right, top, 0));
        bbox.min.sub(new Vector3(left, bottom, 0));
        return bbox;
    }
    getBoundary(distance) {
        const { top, left, right, bottom } = this.settings.padding2D;
        const boundary = this.getBoundingBoxProjectionBox(distance, this.bbox);
        boundary.maxX += right;
        boundary.maxY += top;
        boundary.minX -= left;
        boundary.minY -= bottom;
        return boundary;
    }
    intersects(distance) {
        const boundary = this.getBoundary(distance);
        const result = this.screenBoxes.find(isBoxIntersectsBoundary(boundary));
        return !!result;
    }
    getBoundingBoxProjectionBox(distance, bbox) {
        const camera = this.positionService.getCameraAtDistance(distance);
        return this.boundingService.getBoundingBoxProjection(bbox, camera, this.screenSize);
    }
}
//# sourceMappingURL=IntersectionService.js.map